import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { HOST_IMAGE, EXPERT_IMAGES, EXPERT_INFO } from '@/data/experts';

export const ExpertPanel = ({ podcast, activeSpeaker, revealed }) => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: revealed ? 1 : 0.15 }}
    transition={{ duration: 0.8 }}
    className="mb-8"
  >
    <div className="flex justify-center mb-3">
      <div className="flex items-center">
        <motion.div
          className={`relative w-16 h-16 sm:w-20 sm:h-20 rounded-full border-2 overflow-hidden z-10 transition-all duration-300 ${activeSpeaker === 'host' ? 'scale-110 shadow-[0_0_24px_rgba(109,40,217,0.7)]' : ''}`}
          style={{ borderColor: activeSpeaker === 'host' ? '#A78BFA' : '#6D28D9' }}
          data-testid="host-avatar"
          initial={!revealed ? { scale: 0.8 } : {}}
          animate={revealed ? { scale: 1 } : { scale: 0.8, filter: 'blur(4px)' }}
        >
          <img src={HOST_IMAGE} alt="Host Alex" className="w-full h-full object-cover" />
          {activeSpeaker === 'host' && <div className="absolute inset-0 rounded-full animate-ping" style={{ backgroundColor: 'rgba(109,40,217,0.15)' }} />}
        </motion.div>

        {podcast.experts.map((expertId, index) => {
          const isActive = activeSpeaker === expertId;
          return (
            <motion.div
              key={expertId}
              className={`relative w-14 h-14 sm:w-18 sm:h-18 rounded-full border-2 overflow-hidden -ml-3 transition-all duration-300 ${isActive ? 'scale-125 shadow-[0_0_28px_rgba(109,40,217,0.8)] !z-20 !-ml-1' : ''}`}
              style={{ borderColor: isActive ? '#A78BFA' : '#1C1C21', zIndex: isActive ? 20 : 9 - index }}
              data-testid={`expert-avatar-${expertId}`}
              initial={!revealed ? { scale: 0.7, opacity: 0.3 } : {}}
              animate={revealed ? { scale: isActive ? 1.25 : 1, opacity: 1, filter: 'blur(0px)' } : { scale: 0.7, opacity: 0.3, filter: 'blur(6px)' }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <img
                src={EXPERT_IMAGES[expertId]}
                alt={expertId}
                className={`w-full h-full object-cover transition-all duration-300 ${isActive ? '' : activeSpeaker ? 'opacity-40 grayscale' : ''}`}
              />
              {isActive && (
                <>
                  <div className="absolute inset-0 rounded-full border-2 border-purple-400 animate-pulse" />
                  <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 px-2 py-0.5 rounded-full text-[8px] font-bold whitespace-nowrap" style={{ backgroundColor: '#6D28D9', color: '#F8FAFC' }}>
                    {EXPERT_INFO[expertId]?.name?.split(' ').pop()}
                  </div>
                </>
              )}
            </motion.div>
          );
        })}
      </div>
    </div>

    <AnimatePresence>
      {revealed && (
        <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3 }} className="flex flex-wrap justify-center gap-2 mt-4">
          <span className="px-3 py-1 rounded-full text-[10px] font-medium" style={{ backgroundColor: 'rgba(109,40,217,0.15)', color: '#A78BFA' }}>
            Alex (Host)
          </span>
          {podcast.experts.map(eid => (
            <span key={eid} className="px-3 py-1 rounded-full text-[10px] font-medium" style={{ backgroundColor: 'rgba(255,255,255,0.05)', color: '#94A3B8' }}>
              {EXPERT_INFO[eid]?.name || eid}
            </span>
          ))}
        </motion.div>
      )}
    </AnimatePresence>

    {!revealed && (
      <p className="text-center text-xs mt-4" style={{ color: '#64748B' }}>Press play to reveal the panel</p>
    )}
  </motion.div>
);
